import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AssetType } from '../../models/AssetType';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class TypeProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/type';

  getTypes(): Observable<ApiResponse<AssetType[]>> {
    return this.httpClient.get<ApiResponse<AssetType[]>>(`${this.baseUrl}/all`);
  }

  upsertType(type: AssetType): Observable<ApiResponse<AssetType>> {
    return this.httpClient.post<ApiResponse<AssetType>>(`${this.baseUrl}`, type);
  }
}
